/** 글자를 정규식 안에 그대로 넣을 수 있게 (`.`·`(`·`?` 같은 기호 앞에 `\`) */
export function escapeRe(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}
